import { render, staticRenderFns } from "./dms.vue?vue&type=template&id=0032f161"
import script from "./dms.vue?vue&type=script&lang=js"
export * from "./dms.vue?vue&type=script&lang=js"
import style0 from "./dms.vue?vue&type=style&index=0&id=0032f161&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports